import React from "react";
import styled from "styled-components";
const GraphicButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green
      ? "#0adb93"
      : props.red
      ? "#db0a41"
      : props.layout === "middle"
      ? "#202731"
      : "#181d25"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  min-height: 50px;
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 1em;
  justify-content: center;
  align-items: center;
  text-align: center;
  cursor: pointer;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;
function PlayerStats({ component, game, player, previewGraphic }) {
  return (
    <GraphicButton
      onClick={() => {
        debugger;
        previewGraphic("PlayerStats", {
          player,
          team: player?.team,
          game,
          full_frame: component?.data?.options?.size === "FF",
          type: component?.data?.options?.type,
        });
      }}
    >
      {component?.data?.label}
    </GraphicButton>
  );
}

export default PlayerStats;
